const PREFS_KEY = 'hria-prefs';

export type FormDefaultKey =
  | 'lastDonationTypeId'
  | 'lastExpenseTypeId'
  | 'lastIncomeDepartmentId'
  | 'lastIncomeTypeId';

type PrefsRecord = Record<string, unknown>;

export function readPrefs(): PrefsRecord {
  try {
    return JSON.parse(localStorage.getItem(PREFS_KEY) || '{}') as PrefsRecord;
  } catch {
    return {};
  }
}

export function writePrefs(partial: PrefsRecord): void {
  const current = readPrefs();
  localStorage.setItem(PREFS_KEY, JSON.stringify({ ...current, ...partial }));
}

export function getLastFormDefault(key: FormDefaultKey): string | undefined {
  const value = readPrefs()[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

export function setLastFormDefault(key: FormDefaultKey, value: string): void {
  if (!value) return;
  writePrefs({ [key]: value });
}
